import React from "react";
import "./DocumentManagementAiDisclaimer.css";

const DocumentManagementAiDisclaimer = ({ compact = false }) => (
  <div
  className={`doc-mgmt-ai-disclaimer${compact ? " doc-mgmt-ai-disclaimer--compact" : ""}`}
  style={{
    display: 'flex',
    alignItems: 'center',
    padding: '20px 16px'
  }}
  role="note"
  aria-label="AI content disclaimer"
>
  <p 
    className="card-subtitle"
    style={{ margin: 0, textAlign: 'left', lineHeight: 1.4 }}
  >
    Summaries and extracted metadata are AI-assisted and may contain errors.
    Verify all fields against the original document before confirming. This
    platform provides legal information, not legal advice.
  </p>
</div>
);

export default DocumentManagementAiDisclaimer;
